module.exports = __webpack_public_path__ + "img/deanna-lujan.aacb34c5.jpg";